<template>
  <div id="#product-go-for-good" class="campaign-widget">
    <div class="campaign-widget__badge">
      <img
        src="~/assets/images/go_for_good/goforgood-badge.png"
        class="img-responsive"
        alt="Go For Good Badge"
      />
    </div>

    <span class="campaign-widget__institution">
      {{ `${percentage}% ${$t('go_for_good.percentage_support')} ` }}
      <a
        href="#about-thecampaign"
        class="campaign-widget__institution-link"
        data-grass="institution-link"
        @click.prevent="scrollToInstitution"
        >{{ institutionName }}</a
      ></span
    >
    <span class="campaign-widget__amount">
      {{
        `${$t('go_for_good.estimated_amount')}: ${formatPrice(raisedAmount)}`
      }}
    </span>
  </div>
</template>

<script>
import priceable from '~/mixins/priceable'
export default {
  mixins: [priceable],
  props: {
    commissionPercentage: {
      type: [String, Number],
      default: null,
    },
    raisedAmount: {
      type: [String, Number],
      default: null,
    },
    institutionName: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    percentage() {
      return parseInt(Number(this.commissionPercentage))
    },
  },
  methods: {
    scrollToInstitution() {
      this.$emit('scrollToInstitution')
    },
  },
}
</script>

<style lang="scss">
.campaign-widget {
  display: flex;
  flex-direction: column;

  .campaign-widget__badge {
    margin-top: 20px;
    margin-bottom: 6px;

    img {
      display: block;
      height: 20px;
      width: auto;
    }
  }

  .campaign-widget__institution {
    color: #999;
    font-weight: bold;
    line-height: normal;
    margin-bottom: 3px;
  }

  .campaign-widget__institution-link {
    color: #999;
    font-weight: bold;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  .campaign-widget__amount {
    color: $color_pink;
    font-weight: bold;
    margin-bottom: 0;
  }
}

@media (min-width: $screen_large) {
  .campaign-widget {
    .campaign-widget__amount {
      margin-bottom: 10px;
    }
    .campaign-widget__badge {
      margin-top: 0;
    }
  }
}
</style>
